import { PollAnswerDialogComponent } from '../poll-answer-dialog/poll-answer-dialog.component';
import { InvitePollService } from '../../services/invitepoll.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA, MdDialog } from '@angular/material';
import { Observable } from "rxjs";

@Component({
  selector: 'app-poll-dialog',
  templateUrl: './poll-dialog.component.html',
  styleUrls: ['./poll-dialog.component.css']
})
export class PollDialogComponent implements OnInit {

  pollInvitations: Observable<any[]>;
  pollLoading: boolean;
  poll: any;
  pollIMax = 6;
  pollIPage = 1;
  pollITotal = 0;
  pollId: string;
  job_id: string;
  errorMessage: string;

  constructor(
    @Inject(MD_DIALOG_DATA) public data: any,
    public pollI: InvitePollService,
    private dialog: MdDialog,
    public dialogRef: MdDialogRef<PollDialogComponent>) { }

  ngOnInit() {
    this.pollIMax = this.data.pollIMax;
    this.pollId = this.data.pollid;
    this.poll = this.data.poll;
    this.job_id = this.data.job_id;
    this.fetchpolls(1);
  }

  goToPoll(pollInvite) {
    const dialogRef = this.dialog.open(PollAnswerDialogComponent, {data: {
      pollInvite: pollInvite,

    }});
    dialogRef.afterClosed().subscribe(result => {});
  }

  fetchpolls(page) {
    this.pollLoading = true;
    this.pollI.getPollInviteByPoll(this.pollId, page, this.pollIMax, this.job_id)
      .subscribe(
        res => {
          this.pollITotal = res.pagination.total;
          this.pollIPage = page;
          this.pollLoading = false;
          this.pollInvitations = res.pollinvitations;
        },
        error => {
          this.pollLoading = false;
        }
      );
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/poll-dialog/poll-dialog.component.ts